import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import Calling from '../../api/Calling';
import { MdDeleteSweep, MdPreview } from 'react-icons/md';
import genrateCaptch from '../../components/captcha';
import { useNavigate } from 'react-router-dom';
import DeleteButton from '../../components/ul/DeleteButton';
import { formatView } from '../../components/formatView';
import ClickView from '../../components/ul/ClickView';
import NotFound from '../../components/ul/NotFound';
import formatDateTime from '../../components/formatDateTime';
import NavbarLive from './NavbarLive';
import { GiClick } from 'react-icons/gi';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';

const LiveMatchAdsHistory = () => {
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(1);
    const limit = useState(1000);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([])
    const [totalClick, setTotalClicks] = useState(0);
    const [tClick, setTClick] = useState(0);
    const [tView, setTView] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [page]);

    const filterTotalClick = (data) => {
        const totalClicks = data.reduce((acc, i) => acc + i?.a_click, 0);
        setTotalClicks(totalClicks);
    }

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.fireLiveMatchAdWebHistory(page, limit);
            if (resp.status) {
                setTableData(resp?.data);
                setTotalPages(resp?.totalPage || 0);
                setTClick(resp?.totalClicks || 0);
                setTView(resp?.totalViews || 0);
                filterTotalClick(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    const handleDeleteStory = async (id) => {
        setLoader(true);
        try {
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = genrateCaptch(content);
            if (check) {
                const body = {}
                if (!id) {
                    body.id = selectedUsers;
                } else {
                    body.id = [id];
                }
                const response = await Calling.fireLiveMatchAdWebHistoryDelete(body);
                const { status, message } = response;
                if (status) {
                    toast.success(message, { autoClose: 2000 });
                    fetchData();
                    setSelectedUsers([]);
                } else {
                    toast.error(message, { autoClose: 2000 });
                }
            } else {
                toast.error("Ans in not currect", { autoClose: 2000 });

            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    }

    const handleselectRecord = (recordId) => {
        setSelectedUsers((prev) => selectedUsers.includes(recordId) ? prev.filter(id => id !== recordId) : [...prev, recordId]);
    }
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };


    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2"><h1 className="text-xl sm:text-2xl font-bold">Live Match Management
                    </h1>
                    </div>
                    <div className='bg-main-white rounded-xl'>
                        <NavbarLive selectState={'adsHistory'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        <div className=''>
                            <div className=''>
                                <div className='flex justify-between items-center p-6'>
                                    <h1 className='font-bold text-main-font text-2xl'>Live Ads History</h1>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-4 px-6 pb-6 ">
                                    {/* Total View */}
                                    <div
                                        className="flex  flex-col break-words rounded-lg border-[1px] border-blue-600 bg-blue-100 text-main-white  hover:shadow-lg transform transition-all duration-300 cursor-pointer"
                                    >
                                        <div className="flex justify-between items-center p-4">
                                            <div className='items-center'>
                                                <p className="text-sm capitalize  text-main-subfont">Views</p>
                                                <h4 className="tracking-tighter text-xl text-main-font mt-[1px]">
                                                    {tView < 10 ? '0' + tView : formatView(tView)}
                                                </h4>
                                            </div>
                                            <div className='text-main-white bg-blue-600 p-3 rounded-lg items-center'>
                                                <MdPreview size={30} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Click */}
                                    <div
                                        className="flex flex-col break-words rounded-lg border-[1px] border-purple-600 bg-purple-100 text-main-white  hover:shadow-lg transform transition-all duration-300 cursor-pointer"
                                    >
                                        <div className="flex justify-between items-center p-4">
                                            <div className='items-center'>
                                                <p className="text-sm capitalize  text-main-subfont">Click</p>
                                                <h4 className="tracking-tighter text-xl text-main-font mt-[1px]">
                                                    {tClick < 10 ? '0' + tClick : formatView(tClick)}
                                                </h4>
                                            </div>
                                            <div className='text-main-white bg-purple-600 p-3 rounded-lg items-center'>
                                                <GiClick size={30} />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className='overflow-x-auto'>
                                    <table className='w-full rounded-lg overflow-hidden'>
                                        <thead className='bg-main-th text-main-font'>
                                            <tr>
                                                <th className='ps-6 py-3 flex gap-3 mt-1 text-left text-sm font-medium uppercase'>
                                                    <input type='checkbox' onChange={(e) => setSelectedUsers(e.target.checked ? tableData.map(prev => prev._id) : [])} />
                                                    {isNaN(selectedUsers) ? <DeleteButton className=''
                                                        onClick={() => handleDeleteStory()} label={<MdDeleteSweep size={20} />} /> : ''}
                                                </th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>No</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Name</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>View</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Count</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Date</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='divide-y divide-gray-200'>
                                            {tableData.length > 0 ?
                                                tableData.map((v, i) => {
                                                    return (
                                                        <tr key={i} className="border-b hover:bg-main-thHover ">
                                                            <td className="py-3 text-left px-6">
                                                                <input
                                                                    type="checkbox"
                                                                    name="select"
                                                                    className="cursor-pointer "
                                                                    checked={selectedUsers.includes(v._id)}
                                                                    onChange={(e) => handleselectRecord(v?._id)}
                                                                />
                                                            </td>
                                                            <td className="py-3 px-3 text-left">
                                                                {i + 1}
                                                            </td>
                                                            <td className={`py-3 px-3 text-left }`}>
                                                                {v?.a_name}
                                                            </td>

                                                            <td className={`py-3 px-3`}>
                                                                <ClickView label={formatView(v?.a_view)} />
                                                            </td>
                                                            <td className="py-3 px-3">
                                                                <ClickView label={formatView(v?.a_click)} />
                                                            </td>
                                                            <td className="py-3 px-3">
                                                                {
                                                                    formatDateTime(v?.createdAt)
                                                                }
                                                            </td>
                                                            <td className="py-3 mt-3   flex  items-center space-x-2 px-3">
                                                                <DeleteButton onClick={() => handleDeleteStory(v._id)} />
                                                            </td>
                                                        </tr>
                                                    );
                                                }) :
                                                <tr><td className='' colSpan={8}><NotFound /></td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-12 p-4 sm:p-6 relative">
                                    {/* Pagination Controls - Centered on mobile, Left-aligned on larger screens */}
                                    <div className="col-span-1 sm:col-span-6 flex justify-center sm:justify-start mb-4 sm:mb-0">
                                        <div className="flex gap-3 sm:gap-6">
                                            <button
                                                className={`px-2 w-[90px] sm:w-[110px] flex items-center justify-center gap-1 sm:gap-2 py-1.5 sm:py-2 text-sm sm:text-base rounded-lg ${page === 1
                                                    ? "bg-main-white border border-main-border text-main-subfont"
                                                    : "bg-main-blue text-main-white"
                                                    }`}
                                                onClick={() => handlePageChange(page - 1)}
                                                disabled={page === 1}
                                            >
                                                <FaArrowLeft /> Previous
                                            </button>
                                            <button
                                                className={`px-2 w-[90px] sm:w-[110px] flex items-center justify-center gap-1 sm:gap-2 py-1.5 sm:py-2 text-sm sm:text-base rounded-lg ${page === totalPages
                                                    ? "bg-main-white border border-main-border text-main-subfont"
                                                    : "bg-main-blue text-main-white"
                                                    }`}
                                                onClick={() => handlePageChange(page + 1)}
                                                disabled={page === totalPages}
                                            >
                                                Next <FaArrowRight />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Page Number Display - Centered on mobile, Right-aligned on larger screens */}
                                    <div className="col-span-1 sm:col-span-6 flex justify-center sm:justify-end">
                                        <p className="text-main-subfont text-sm sm:text-base">
                                            <span className="border border-main-border text-main-font px-2 py-1 rounded-lg">
                                                {page < 10 ? `0${page}` : page}
                                            </span>{" "}
                                            of {totalPages < 10 ? `0${totalPages}` : totalPages}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveMatchAdsHistory;
